<div class="MainDiv">


  @if (globserv.progressSpinner) {
    <div style="margin-top:100px; display: flex; justify-content: center;  align-items: center;" >
      <mat-spinner></mat-spinner>
    </div>
  }


  @if (globserv.progressSpinner==false) {
    <div >
      @if (globserv.Login.LoginStatus==true) {
        <button  mat-icon-button [matMenuTriggerFor]="menu" class="Menu">
          <mat-icon>more_vert</mat-icon>
        </button>
      }
      <div class="LogoRow">
        <img src="/assets/images/Pasura-Logo-RGB.png"  alt="Pasura-Logo" class="Logo">
      
        @if (globserv.Login.DBScope?.includes('_Test')) {
          <span class="LogoTestSystem"> TEST-SYSTEM</span>
        }
      
      </div>
      <mat-menu #menu="matMenu">
        @if (router.url !='/pasura') {
          <button mat-menu-item  routerLink="pasura" >
            <mat-icon>folder</mat-icon>
            <span>Pasura</span>
          </button>
        }
        @if (this.router.url=='/pasura') {
          <button mat-menu-item  [matMenuTriggerFor]="subMenuPasura">
            <mat-icon>folder</mat-icon>
            <span>Pasura</span>
          </button>
        }
        <button mat-menu-item  routerLink="fileArchiv" >
          <mat-icon>archive</mat-icon>
          <span>File-Archiv</span>
        </button>
        <button mat-menu-item  [matMenuTriggerFor]="subMenuTarifRechner">
          <mat-icon>network_check</mat-icon>
          <span>Tarif-Rechner</span>
        </button>
        <button  routerLink="benutzer" mat-menu-item  >
          <mat-icon>Key</mat-icon>
          <span>Passwort ändern</span>
        </button>
        <button mat-menu-item  routerLink="logout" >
          <mat-icon>exit_to_app</mat-icon>
          <span>Logout</span>
        </button>
        
       @if (globserv.Login.LoginName=='Maurus') {
        <button mat-menu-item  (click)="doTestMM()" >
          <mat-icon>build</mat-icon>
          <span>Test</span>
        </button>
        }
      </mat-menu>
      <mat-menu #subMenuPasura="matMenu">
        <button mat-menu-item  (click)="globserv.setPasuraAction('contactNew')" >
          <span>neuer Kontakt</span>
        </button>
        @if (globserv.kontakt!=undefined) {
          <div>
            @if (showNewPolice()) {
              <button mat-menu-item (click)="globserv.setPasuraAction('policeNew')" >
                <span>neue Police für {{globserv.kontakt.Bexio.nr}}/{{globserv.kontakt.Bexio.name_1}}</span>
              </button>
            }
          </div>
        }
        @if (!showNewPolice()) {
          <div>
            <button mat-menu-item (click)="copySchadenfallLink()" >
              <span>Kopiere URL für Schadenportal von Police {{globserv.policen[0].PolicenNr}}</span>
            </button>
          </div>
        }
        <!--
        <button  routerLink="passwort" mat-menu-item  >
          <span>Passwort ändern</span>
        </button>
        -->
        @if (globserv.kontakt!=undefined) {
          <button  mat-menu-item  (click)="makeContactDocument()" >
            <span>Brief für Kontakt erstellen</span>
          </button>
        }
        <button mat-menu-item  (click)="getAdressListe()" >
          <span>Adressliste erstellen</span>
        </button>
        <button mat-menu-item  (click)="goToTransportListe()" >
          <span>Liste Transportversicherung</span>
        </button>
        <button mat-menu-item  (click)="getPferdeStatistik()" >
          <span>Pferdestatistik erstellen</span>
        </button>
        <button mat-menu-item   >
          <mat-checkbox (click)="toggelPrintLogo()" [checked] = "globserv.Settings.PrintLogo">Druck mit Logo</mat-checkbox>
        </button>
        @if ( globserv.kontakt!=undefined && kontaktHatPolicen()) {
          <button mat-menu-item  (click)="globserv.setPasuraAction('contactDelete')" >
            <span>Kontakt {{globserv.kontakt.Bexio.nr}} löschen </span>
          </button>
        }
      </mat-menu>
      <mat-menu #subMenuTarifRechner="matMenu">
        <!--
        <button mat-menu-item  (click)="goToTrarif('Tarif2020')" >
          <span>TarifGeneration 2020</span>
        </button>
        -->
        <button mat-menu-item  (click)="goToTrarif('Tarif2025')" >
          <span>TarifGeneration 2025</span>
        </button>
        
        <button mat-menu-item  (click)="goToTrarif('Tarif2024')" >
          <span>TarifGeneration 2024</span>
        </button>
        
      </mat-menu>
      <div  class="AppData">
        <router-outlet></router-outlet>
      </div>
    </div>
  }
</div>
